import  vue from "vue"
import Vuex from "Vuex"
vue.use(Vuex);

const state={
 user:false
}
const mutations ={
  //登陆
  login(state,user){
    state.user= user
  },
  //推出
  logout(state,user){
    state.user = false
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js